import { useEffect } from 'react';

export const useDomTitle = (sub_title = '') => {
    const title = `Nokia ZINA BI ${sub_title && `| ${sub_title}`}`;
    useEffect(() => {
        document.title = title;
    }, [title]);
    return [title, useDomTitle];
};
